import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseModel } from '../models/response-model';
import { Paging } from '../models/page';
import { CancellationReason } from '../models/cancellation-reason';

@Injectable({
  providedIn: 'root'
})
export class CancellationReasonService {
  private url = `${environment.url}/cancellationReasons`;
  constructor(private http: HttpClient) { }

  readCancellationReasons() {
    let params = new HttpParams();
    params = params
      .set("page", "0")
      .set("pageSize", "999999999")
    return this.http.get<ResponseModel<Paging<Array<CancellationReason>>>>(this.url, { params });
  }
}
